import styled from 'styled-components';

import BaseFinawardsIcon from '@/components/Base/FinawardsIcon';
import Icon from '@/components/Base/Icon';
import { colorBlack900, mediaQueryLaptopMin } from '@/styleUtils';

export const ProductAdvantagesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  flex: 0 0 100%;
`;

export const ProductAdvantagesList = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const ProductAdvantage = styled.span`
  align-items: center;
  color: ${colorBlack900};
  display: inline-flex;
  font-size: 12px;
  line-height: 31px;
  height: 32px;

  &:not(:last-child) {
    margin-right: 12px;
  }

  @media ${mediaQueryLaptopMin} {
    &:not(:last-child) {
      margin-right: 16px;
    }
  }
`;

export const CheckIcon = styled(Icon).attrs({ name: 'check' })`
  fill: #239c13;
  height: 16px;
  margin-right: 5px;
  width: 11px;
`;

export const FinawardsIcon = styled(BaseFinawardsIcon)`
  margin-left: 5px;
`;
